import * as React from "react";

import { cn } from "../../lib/utils";

const TabControlsContainer = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <div
        className={`rounded-lg bg-white p-4 w-full ${cn("", className)}`}
        ref={ref}
        {...props}
      >
        {props.children}
      </div>
    );
  }
);
TabControlsContainer.displayName = "TabControlsContainer";

export { TabControlsContainer };
